<template>
  <div class="overlay d-flex">
    <div class="m-auto d-flex flex-column">
      <LoadingIndicator class="m-auto" />
      <vue-typer class="m-auto font-weight-bold" text="Lade ..." />
    </div>
  </div>
</template>

<script>
import LoadingIndicator from './LoadingIndicator';
export default {
  name: 'LoadingOverlay',
  components: { LoadingIndicator },
  props: {},
  mounted() {},
  destroyed() {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(5px);
}
</style>
